/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionDetailResponse } from './SectionDetailResponse';
import {
    SectionDetailResponseFromJSON,
    SectionDetailResponseFromJSONTyped,
    SectionDetailResponseToJSON,
    SectionDetailResponseToJSONTyped,
} from './SectionDetailResponse';
import type { PageModel } from './PageModel';
import {
    PageModelFromJSON,
    PageModelFromJSONTyped,
    PageModelToJSON,
    PageModelToJSONTyped,
} from './PageModel';

/**
 * 
 * @export
 * @interface SectionDetailResponsePagedResult
 */
export interface SectionDetailResponsePagedResult {
    /**
     * 
     * @type {PageModel}
     * @memberof SectionDetailResponsePagedResult
     */
    pageInfo?: PageModel;
    /**
     * 
     * @type {Array<SectionDetailResponse>}
     * @memberof SectionDetailResponsePagedResult
     */
    data: Array<SectionDetailResponse> | null;
}

/**
 * Check if a given object implements the SectionDetailResponsePagedResult interface.
 */
export function instanceOfSectionDetailResponsePagedResult(value: object): value is SectionDetailResponsePagedResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function SectionDetailResponsePagedResultFromJSON(json: any): SectionDetailResponsePagedResult {
    return SectionDetailResponsePagedResultFromJSONTyped(json, false);
}

export function SectionDetailResponsePagedResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionDetailResponsePagedResult {
    if (json == null) {
        return json;
    }
    return {
        
        'pageInfo': json['pageInfo'] == null ? undefined : PageModelFromJSON(json['pageInfo']),
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(SectionDetailResponseFromJSON)),
    };
}

export function SectionDetailResponsePagedResultToJSON(json: any): SectionDetailResponsePagedResult {
    return SectionDetailResponsePagedResultToJSONTyped(json, false);
}

export function SectionDetailResponsePagedResultToJSONTyped(value?: SectionDetailResponsePagedResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageInfo': PageModelToJSON(value['pageInfo']),
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(SectionDetailResponseToJSON)),
    };
}

